import { ServiceFetch } from '../service-fetch'

export default class CustomerTierModel extends ServiceFetch {
    getCustomerTierListBy = (data) => this.authFetch({
        url: 'customer-tier-list/getCustomerTierListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}